import { Skeleton as HeroUISkeleton } from '@heroui/react';
import { twMerge } from 'tailwind-merge';

export function Skeleton({
    className,
    children,
    label,
}: {
    className?: string;
    children?: React.ReactNode;
    label?: string; // used for adding labels to skeleton placeholders in storybook
}) {
    return (
        <HeroUISkeleton className={twMerge(className)} data-chromatic="ignore">
            {label && <div className="flex h-full items-center justify-center text-lg text-slate-grey">{label}</div>}
            {children}
        </HeroUISkeleton>
    );
}
